import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/gb.json';
import translationBG from './locales/bg.json';

const resources = {
  gb: {
    translation: translationEN
  },
  bg: {
    translation: translationBG
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'gb',
    interpolation: {
      escapeValue: false // React already sanitizes content
    }
  });

export default i18n;
